import React from 'react'
import { SearchableItem } from './SelectEntitiesForm.types'
import { SelectEntitiesFormView } from './SelectEntitiesFormView'
import { SelectEntitiesModalQueryContext } from './context'
import { SelectedEntitiesContext } from 'front-end/src/components/common/selectEntitiesForm/context'

export const SelectEntitiesFormController: React.FC = () => {
  const { selectedIds, setSelectedIds } = React.useContext(
    SelectedEntitiesContext
  )

  const { items, setQuery, query } = React.useContext(
    SelectEntitiesModalQueryContext
  )

  const selectItem = React.useCallback(
    (id: SearchableItem['id']) => {
      if (selectedIds.has(id)) {
        selectedIds.delete(id)
      } else {
        selectedIds.add(id)
      }
      setSelectedIds(new Set(selectedIds)) // create new set to trigger re-render
    },
    [selectedIds]
  )

  const resetQuery = React.useCallback(() => {
    setQuery('')
  }, [setQuery])

  return (
    <SelectEntitiesFormView
      selectedIds={selectedIds}
      items={items}
      changeQuery={setQuery}
      selectItem={selectItem}
      query={query}
      resetQuery={resetQuery}
    />
  )
}
